import { render, staticRenderFns } from "./ReportsTableView.vue?vue&type=template&id=5ca07262&"
import script from "./ReportsTableView.vue?vue&type=script&lang=js&"
export * from "./ReportsTableView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports